var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBarsSolid(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 15,
    viewBox: "0 0 16 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M0 1.29167C0 0.646354 0.510714 0.125 1.14286 0.125H14.8571C15.4893 0.125 16 0.646354 16 1.29167C16 1.93698 15.4893 2.45833 14.8571 2.45833H1.14286C0.510714 2.45833 0 1.93698 0 1.29167ZM0 7.125C0 6.47969 0.510714 5.95833 1.14286 5.95833H14.8571C15.4893 5.95833 16 6.47969 16 7.125C16 7.77031 15.4893 8.29167 14.8571 8.29167H1.14286C0.510714 8.29167 0 7.77031 0 7.125ZM16 12.9583C16 13.6036 15.4893 14.125 14.8571 14.125H1.14286C0.510714 14.125 0 13.6036 0 12.9583C0 12.313 0.510714 11.7917 1.14286 11.7917H14.8571C15.4893 11.7917 16 12.313 16 12.9583Z",
    fill: "#1A2021"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBarsSolid);
export default __webpack_public_path__ + "static/media/bars-solid.1323c60db8f0d8c63b204bedde9af87c.svg";
export { ForwardRef as ReactComponent };